import React from 'react';
import { Form } from 'react-bootstrap';

// 약관 동의 체크박스 (가입 화면 + /terms-agree 공용)
// 문서 원본은 랜딩(washnote.kr)에서 단일 관리하고 여기선 링크만 건다.
const TERMS_URL = 'https://washnote.kr/terms.html';
const PRIVACY_URL = 'https://washnote.kr/privacy.html';

const TermsAgreement = ({ agreedTerms, agreedPrivacy, onChangeTerms, onChangePrivacy, disabled }) => {
    const allChecked = agreedTerms && agreedPrivacy;

    const toggleAll = (checked) => {
        onChangeTerms(checked);
        onChangePrivacy(checked);
    };

    return (
        <div className="terms-agreement">
            <Form.Check
                type="checkbox"
                id="agree-all"
                className="terms-agree-all"
                label={<strong>전체 동의</strong>}
                checked={allChecked}
                onChange={(e) => toggleAll(e.target.checked)}
                disabled={disabled}
            />
            <div className="terms-agree-items">
                <Form.Check
                    type="checkbox"
                    id="agree-terms"
                    checked={agreedTerms}
                    onChange={(e) => onChangeTerms(e.target.checked)}
                    disabled={disabled}
                    label={
                        <>
                            <span className="text-danger">[필수]</span>{' '}
                            <a href={TERMS_URL} target="_blank" rel="noopener noreferrer">이용약관</a>에 동의합니다.
                        </>
                    }
                />
                <Form.Check
                    type="checkbox"
                    id="agree-privacy"
                    checked={agreedPrivacy}
                    onChange={(e) => onChangePrivacy(e.target.checked)}
                    disabled={disabled}
                    label={
                        <>
                            <span className="text-danger">[필수]</span>{' '}
                            <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer">개인정보 수집·이용</a>에 동의합니다.
                        </>
                    }
                />
            </div>
        </div>
    );
};

export default TermsAgreement;
